import { render } from "./AcademicYearForm.vue?vue&type=template&id=217a4085"
import script from "./AcademicYearForm.vue?vue&type=script&lang=js"
export * from "./AcademicYearForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__